import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-[#2A2A2A] bg-[#0A0A0A]" data-testid="site-footer">
      {/* top strip — mini legal nav */}
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 pt-8 pb-6 flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-[13px]">
        <span className="inline-flex items-center gap-2 text-[#A8A8A8]">
          <ShieldCheck className="w-4 h-4 text-[#C0C0C0]" strokeWidth={2}/> UK GDPR
        </span>
        <Link to="/privacy" className="text-[#A8A8A8] hover:text-[#F5F5F5] underline underline-offset-4 decoration-[#2A2A2A] hover:decoration-[#C0C0C0] transition-colors" data-testid="footer-privacy-link">Privacy Notice</Link>
        <Link to="/terms" className="text-[#A8A8A8] hover:text-[#F5F5F5] underline underline-offset-4 decoration-[#2A2A2A] hover:decoration-[#C0C0C0] transition-colors" data-testid="footer-terms-link">Terms &amp; Conditions</Link>
        <Link to="/security" className="text-[#A8A8A8] hover:text-[#F5F5F5] underline underline-offset-4 decoration-[#2A2A2A] hover:decoration-[#C0C0C0] transition-colors" data-testid="footer-security-link">Security &amp; Retention</Link>
        <Link to="/contact" className="text-[#A8A8A8] hover:text-[#F5F5F5] underline underline-offset-4 decoration-[#2A2A2A] hover:decoration-[#C0C0C0] transition-colors" data-testid="footer-contact-link">Contact</Link>
      </div>

      {/* main columns */}
      <div className="border-t border-[#2A2A2A]">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-8 py-12 grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand column */}
          <div>
            <img src="/pnc-logo-white.png" alt="PNC UNIQUE" className="h-20 w-auto mb-3 -ml-2" data-testid="footer-logo"/>
            <div className="pnc-eyebrow mb-6">Absence Notifications Portal</div>

            <div className="text-[#A8A8A8] text-[13px] leading-relaxed space-y-1">
              <div>Registered in England and Wales</div>
              <div>Headlands House</div>
              <div>1 Kings Court</div>
              <div>Kettering Parkway</div>
              <div>Kettering</div>
              <div>Northamptonshire</div>
              <div>NN15 6WJ</div>
            </div>

            <div className="mt-6 text-[13px] text-[#A8A8A8]">
              <div className="mb-1">ICO Registration <span className="text-[#F5F5F5] font-medium">ZB865873</span></div>
            </div>

            <div className="mt-6 text-[13px] space-y-1">
              <div><a href="mailto:admin@pncunique.com" className="text-[#D0D0D0] hover:text-[#F5F5F5]">admin@pncunique.com</a></div>
              <div><a href="tel:03330905024" className="text-[#D0D0D0] hover:text-[#F5F5F5]">0333 090 5024</a></div>
              <div><a href="https://www.pncunique.com" target="_blank" rel="noopener noreferrer" className="text-[#D0D0D0] hover:text-[#F5F5F5]">www.pncunique.com</a></div>
            </div>
          </div>

          {/* About column */}
          <div>
            <div className="pnc-eyebrow mb-4">About</div>
            <ul className="space-y-3 text-[14px]">
              <li><a href="https://www.pncunique.com" target="_blank" rel="noopener noreferrer" className="text-[#D0D0D0] hover:text-[#F5F5F5]">About PNC UNIQUE LTD</a></li>
              <li><Link to="/contact" className="text-[#D0D0D0] hover:text-[#F5F5F5]">Contact HR</Link></li>
              <li><a href="https://www.pncunique.com" target="_blank" rel="noopener noreferrer" className="text-[#D0D0D0] hover:text-[#F5F5F5]">Company website</a></li>
            </ul>
          </div>

          {/* Legal column */}
          <div>
            <div className="pnc-eyebrow mb-4">Legal</div>
            <ul className="space-y-3 text-[14px]">
              <li><Link to="/privacy" className="text-[#D0D0D0] hover:text-[#F5F5F5]">Privacy Notice</Link></li>
              <li><Link to="/terms" className="text-[#D0D0D0] hover:text-[#F5F5F5]">Terms &amp; Conditions</Link></li>
              <li><Link to="/security" className="text-[#D0D0D0] hover:text-[#F5F5F5]">Security &amp; Retention</Link></li>
            </ul>
          </div>
        </div>
      </div>

      {/* bottom line */}
      <div className="border-t border-[#2A2A2A]">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-8 py-5 text-center text-[12px] text-[#6B6B6B]">
          © {new Date().getFullYear()} PNC UNIQUE LTD. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
